/* eslint-disable @typescript-eslint/no-unused-vars */
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationExtras,
  Params,
  Router,
} from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import {
  AlertDialogAction,
  AlertDialogComponent,
  AlertDialogConfig,
} from './../dialogs/alert-dialog/alert-dialog.component';
import { BaseService } from './helperclasses/baseservice';
import { UrlTreeParam } from '@app/models/course';

export interface OpenUrlConfig {
  mouseEvent?: RoutingMouseEvent;
  openInNewTab?: boolean;
  resetBreadCrumbs?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryParams?: any;
}

export type RoutingMouseEvent =
  | MouseEvent
  | { openInNewTab?: boolean; ctrlKey?: boolean; metaKey?: boolean };
@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class RoutingService extends BaseService {
  private redirectUrl!: string | undefined;
  private redirectUrlIsNew = false;
  constructor(
    private dialogService: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
  ) {
    super();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (
          !router.getCurrentNavigation()?.extras?.state ||
          !this.router.getCurrentNavigation()?.extras?.state?.[
            'keepRedirectUrl'
          ]
        ) {
          this.resetRedirectUrl();
        }
        this.redirectUrlIsNew = false;
        //this.resetRedirectUrl()
      });
  }

  getCurrentRoute() {
    return this.router.routerState.snapshot.url;
  }

  setRedirectUrl(redirectUrl?: string) {
    if (!redirectUrl) {
      redirectUrl = this.getCurrentRoute();
    }
    this.redirectUrl = redirectUrl;
    this.redirectUrlIsNew = true;
  }

  renewRedirectUrl() {
    this.redirectUrlIsNew = true;
  }

  resetRedirectUrl() {
    this.redirectUrl = undefined;
    this.redirectUrlIsNew = false;
  }

  get clientId() {
    return this.route.snapshot?.firstChild?.params['clientId'];
  }

  public openUrl(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    url: any[],
    navigationExtras?: NavigationExtras,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mouseEvent?: any,
    resetBreadCrumbs?: boolean,
    openInNewTab?: boolean,
  ) {
    if (
      openInNewTab ||
      (mouseEvent &&
        (mouseEvent.ctrlKey || mouseEvent.metaKey || mouseEvent.openInNewTab))
    ) {
      const urlTree = this.router.createUrlTree(url, navigationExtras);
      if (mouseEvent?.shiftKey) {
        window.open(
          urlTree.toString(),
          '_blank',
          'location=yes,height=570,width=520,scrollbars=yes,status=yes,modal=yes',
        );
      } else {
        window.open(urlTree.toString());
      }
    } else {
      if (this.redirectUrl && !this.redirectUrlIsNew) {
        url = [this.redirectUrl];
        this.resetRedirectUrl();
      }
      this.router.navigate(url, {
        ...navigationExtras,
        state: {
          ...navigationExtras?.state,
          keepRedirectUrl: this.redirectUrlIsNew,
        },
      }); //navigationExtras) //
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    return this.router.navigate(commands, extras);
  }

  public setUrl(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    url: any[],
    navigationExtras?: NavigationExtras,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mouseEvent?: any,
    resetBreadCrumbs?: boolean,
    openInNewTab?: boolean,
  ) {
    const routeUrl = this.router
      .createUrlTree(url, {
        relativeTo: this.route,
        queryParams: navigationExtras?.queryParams,
      })
      .toString();
    this.location.go(routeUrl);
  }

  public openAlertDialog(
    title: string,
    body: string,
    actions: AlertDialogAction[],
    config?: AlertDialogConfig,
  ) {
    return this.dialogService
      .open(AlertDialogComponent, {
        data: {
          title: title,
          body: body,
          actions: actions,
          config: config,
        },
      })
      .afterClosed();
  }

  routeToPage(url: string, params?: UrlTreeParam[]) {
    if (params) {
      url += '?';
      params.forEach((param) => {
        url += `${param.key}=${param.value}&`;
      });
      url = url.slice(0, -1);
    }

    if (url.startsWith('/')) {
      const queryParams: Params = {};
      if (params) {
        params.forEach((param) => {
          queryParams[param.key] = param.value;
        });
      }

      this.openUrl([url], {
        queryParams: queryParams,
      });
    } else {
      if (params) {
        url += '?';
        params.forEach((param) => {
          url += `${param.key}=${param.value}&`;
        });
        url = url.slice(0, -1);
      }
      if (url.startsWith('http')) {
        window.open(url, '_blank');
      } else {
        window.open(url);
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public openProfileLink(queryParams?: any, mouseEvent?: RoutingMouseEvent) {
    this.openUrl(['profile'], { queryParams: queryParams }, mouseEvent);
  }

  public reloadComponent() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
}
